// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".letters-counter{text-align:right;font-family:\"GothamSSm-Book\",Arial,sans-serif;font-size:12px;color:#a9a9a9}.letters-counter .invalid{color:#ea5858}\n", ""]);
// Exports
module.exports = exports;
